"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createViewId = exports.createEventId = exports.getSystemTime = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var utilities_1 = require("./utilities");
function getSystemTime() {
    return firefly_utilities_helper_ts_1.getSystemDate().toISOString();
}
exports.getSystemTime = getSystemTime;
function createEventId() {
    return utilities_1.createRandomHexValue() + getSystemTime();
}
exports.createEventId = createEventId;
function createViewId() {
    return utilities_1.createHashValue();
}
exports.createViewId = createViewId;
